module.exports = __webpack_public_path__ + "img/elephant.5c52c4f2.svg";